import {
  Language,
  SupportedLanguages,
} from "@/components/language/supported-languages";
import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { useUserInformation } from "@/hooks/api/useUserProfileApi";

// import { useUserInformation } from "@/hooks/api/useUserProfileApi";

export type Proficiency = "A1" | "A2" | "B1" | "B2" | "C1" | "C2";
export interface LanguageProficiency {
  language: Language;
  proficiency: Proficiency;
}

interface LearnLanguageContextProps {
  languageProficiency: LanguageProficiency | undefined;
  isLoading: boolean;
  isError: boolean;
  setLanguageProficiency: (lang: LanguageProficiency) => void;
}

const LearnLanguageContext = createContext<
  LearnLanguageContextProps | undefined
>(undefined);

export const LearnLanguageProvider = ({
  children,
}: {
  children: ReactNode;
  initialLanguage?: Language;
}) => {
  const { data: userInformation, isLoading, isError } = useUserInformation();
  const [languageProficiency, setLanguageProficiency] = useState<
    LanguageProficiency | undefined
  >();

  useEffect(() => {
    if (userInformation?.learnLanguages?.length) {
      const firstLearnLang = userInformation.learnLanguages[0];
      const langDetails = SupportedLanguages.find(
        (lang) => lang.key === firstLearnLang.languageCode,
      );
      if (langDetails) {
        setLanguageProficiency({
          language: langDetails,
          proficiency: firstLearnLang.proficiency.toUpperCase() as Proficiency,
        });
      }
    }
  }, [userInformation]);

  return (
    <LearnLanguageContext.Provider
      value={{
        languageProficiency,
        isLoading,
        isError,
        setLanguageProficiency,
      }}
    >
      {children}
    </LearnLanguageContext.Provider>
  );
};

export const useLearnLanguage = () => {
  const context = useContext(LearnLanguageContext);
  if (!context) {
    throw new Error(
      "useLearnLanguage must be used within a LearnLanguageProvider",
    );
  }
  return context;
};
